import { render, staticRenderFns } from "./DecisionPurposeList.vue?vue&type=template&id=696e7844&"
import script from "./DecisionPurposeList.vue?vue&type=script&lang=js&"
export * from "./DecisionPurposeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports